// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-wrapper[data-v-61150bde]{width:90%;max-width:714px}svg[data-v-61150bde]{height:143px!important}", ""]);
// Exports
module.exports = exports;
